import styles from './MnpListItem.module.css'
import {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import TableItem from "../../FormTemplate/TableItem/TableItem";

interface IMnpListItem
{
    ctn:string
    tempCtn:string
    icc:string
    createdAt: string


}

export default function MnpListItem()
{
    const dataMnpList = useRef(null)
    const [ldrMnpList,rsMnpList,exMnpList] = useApiQuery("/order/process/mnp/list","post",dataMnpList);
    const [mnpList, setMnpList] = useState<IMnpListItem[]>([])


    useEffect(()=>{
        loadMnpList()
    },[dataMnpList])

    const loadMnpList = () =>{
        exMnpList().then((e)=>{
            if(e?.success)
            {
                setMnpList(e?.payload)
                return
            }
        })
    }

    return(
        <div className={styles.mainCont}>
            <TableItem
                data={mnpList}
                onReload={loadMnpList}
                column={[
                    {
                        title: "Дата заказа",
                        fieldId: "createdAt",
                        type: 4,
                        mode: "s"
                    },
                    {
                        title: "Заказ",
                        fieldId: "orderId",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Оператор",
                        fieldId: "operId",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "ФИО",
                        fieldId: "fio",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Номер",
                        fieldId: "ctn",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Вр. номер",
                        fieldId: "tempCtn",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Тариф",
                        fieldId: "tarifName",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Донор",
                        fieldId: "srcOper",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Регион",
                        fieldId: "regionName",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Заметка",
                        fieldId: "adminNote",
                        type: 0,
                        mode: ""
                    },

                ]}
                onPageCount={50}
                exportExcel={true}
            />
        </div>
    )
}